import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Nav from "@visa/vds/nav";
import NavPanel from "@visa/vds/nav-panel";
import NavVerticalFooter from "@visa/vds/nav-vertical-footer";
import NavVerticalToggleButton from "@visa/vds/nav-vertical-toggle-button";
import ButtonAction from "@visa/vds/button-action";
import Icon from "@visa/vds/icon";
import NavLinks from "@visa/vds/nav-links";
import TabList from "@visa/vds/tab-list";
import { MCSNavPanelTab } from "./MCSNavPanelTab";
import "styles/SideNav.css";

function MCSSideNavPanel(props) {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(props.collapsed === true ? false : true);

  const handleRouting = (dir, key) => {
    props.setTabSelected(key);
    history.push(dir);
  };

  function renderTab(tab) {
    if (tab.visible !== undefined && !tab.visible) return <></>;

    switch (tab.type) {
      case "menu": return MCSNavPanelTab.TabMenu(tab.iconName, tab.label, tab.parentState, tab.openParent);
      case "child": return MCSNavPanelTab.TabChild(tab.iconName, tab.label, tab.parentState, handleRouting, tab.route);
      case "item": return MCSNavPanelTab.TabItem(tab.iconName, tab.label, handleRouting, tab.route);
      case "vstsSSOMenuItem": return MCSNavPanelTab.NewTabChildButton(tab.iconName, tab.label, tab.parentState);
      default: return <></>;
    }
  }

  useEffect(() => {
    console.log('pathname: ', location.pathname);
    props.tabList && props.tabList.map((tab, i) => {
      if (tab.route && tab.route == location.pathname) {
        props.setTabSelected(i);
      }
    })
  }, [props.tabList]);

  return (
    <>
      <Nav
        id="leftNavPanel"
        orientation="vertical"
        size={open ? undefined : "mini"}
        type="light"
      >
        <NavPanel className="vss-side-nav-panel">
          <NavVerticalFooter>
            <NavVerticalToggleButton
              aria-expanded={open ? "true" : "false"}
              aria-label="navigation control"
              onClick={() => setOpen(!open)}
            >
              <ButtonAction>
                {open ? (
                  <Icon name="arrow-previous" resolution="tiny" />
                ) : (
                  <Icon name="arrow-next" resolution="tiny" />
                )}
              </ButtonAction>
            </NavVerticalToggleButton>
          </NavVerticalFooter>
          <NavLinks ariaLabel={props.ariaLabel}>
            <TabList orientation="vertical" selectedTab={props.tabSelected}>
              {props.tabList && props.tabList.map((tab, i) => {
                return renderTab(tab);
              })}
            </TabList>
          </NavLinks>
        </NavPanel>
      </Nav>
    </>
  );
}

export default MCSSideNavPanel;
